// extracted by mini-css-extract-plugin
export default {"subHeading":"contact-control-panel-sub-heading_subHeading__sFAB1"};